import { render, staticRenderFns } from "./user-payment.vue?vue&type=template&id=5c262fa1&"
import script from "./user-payment.vue?vue&type=script&lang=js&"
export * from "./user-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports